var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.videoId && _vm.$slots.videoImage
    ? _c(
        "div",
        [
          _vm._t("videoTitle"),
          _vm._v(" "),
          _c("div", { staticClass: "youtube-embed__color-wrap" }, [
            _vm.loadIframe
              ? _c("div", { staticClass: "youtube-embed__iframe-wrapper" }, [
                  _c("iframe", {
                    attrs: {
                      width: "100%",
                      height: "100%",
                      src: _vm.videoSource,
                      frameborder: "0",
                      allow: "autoplay",
                      allowfullscreen: "",
                    },
                  }),
                ])
              : _c(
                  "div",
                  { staticClass: "youtube-embed__placeholder-img-wrapper" },
                  [
                    _vm._t("videoImage"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "youtube-embed__play-button",
                        attrs: { type: "button" },
                        on: { click: _vm.loadVideo },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/static/c5/g/layoutid_RWJOB/applications/play.svg",
                            alt: "located",
                          },
                        }),
                      ]
                    ),
                  ],
                  2
                ),
          ]),
          _vm._v(" "),
          _vm._t("videoDescription"),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }